<div class="container-fluid g-0 m-0">
  <div class="row d-flex align-items-center ms-5 me-5 mt-4">
    <div class="col-auto d-flex pe-4 justify-content-end cursor-pointer">
      <div class="button-back pb-1" [routerLink]="backLink">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col g-0 m-0 p-3 rounded download-section" (click)="getTemplate()">
      <div class="d-flex justify-content-center align-items-center ps-2 pe-2 pt-1 pb-1">
        <span class="sample-file-inner p-1 pt-0 pb-0 pe-2 d-flex align-items-center">
          <svg-icon alt="Sample file" class="custom-hight-csv" src="assets/settings/xls-icon.svg"></svg-icon>
        </span>
        <span class="ps-2">{{ sampleFileText | translate }}</span>
      </div>
    </div>
  </div>
  <div class="row g-0 m-0 p-2 m-5 mt-4 mb-4 rounded upload-section pt-5 pb-5 align-items-center" appDragAndDrop
    (click)="onFileSelected($event)">
    <input #fileInput type="file" (change)="onFileSelected($event)" accept=".xlsx" />
    <svg-icon alt="Upload" class="d-flex justify-content-center" src="assets/settings/upload-arrow.svg"></svg-icon>
    <span class="d-flex justify-content-center">{{
      "DRAGANDDROP" | translate
      }}</span>
  </div>
  <div class="row g-0 m-0 m-5 mt-0 rounded table-section pb-3">
    <table>
      <thead>
        <tr>
          <td>
            <img alt="Column" src="assets/device/column-menu.svg" />
            <span>{{ "UPLOADIDCAPS" | translate }}</span>
          </td>
          <td>
            <img alt="Column" src="assets/device/column-menu.svg" />
            <span>{{ "DATE" | translate | uppercase }}</span>
          </td>
          <td>
            <img alt="Column" src="assets/device/column-menu.svg" />
            <span>{{ "PROCESSED" | translate | uppercase }}</span>
          </td>
          <td>
            <img alt="Column" src="assets/device/column-menu.svg" />
            <span>{{ "STATUS" | translate | uppercase }}</span>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data; let i = index">
          <td title="{{ row.path }}">{{ row.path }}</td>
          <td>{{ row.dateTime | date: "dd MMM yyyy HH:mm a" : timezoneString }}</td>
          <td>
            <div *ngIf="row.processedRows != null && row.totalRows != null"
              class="progress custom-progress position-relative">
              <div class="progress-bar custom-progress-bar" [style.width.%]="
                    row.totalRows !== 0 ? (row.processedRows / row.totalRows) * 100 : 0
                  " [ngClass]="{
                  'processing': row.processedRows > 0 && row.processedRows < row.totalRows
                }" aria-valuemin="0" [attr.aria-valuemax]="row.totalRows" [attr.aria-valuenow]="row.processedRows">
              </div>

              <div *ngIf="row.processedRows != null && row.totalRows != null"
                class="progress-text position-absolute top-50 start-50 translate-middle custom-progress-text">
                {{ row.processedRows }} / {{ row.totalRows }}
              </div>
            </div>
          </td>
          <td>
            <span [ngClass]="{
                'label-box': true,
                'not-processed': row.status === 'NotProcessed',
                processing: row.status === 'Processing',
                processed: row.status === 'Processed',
                failed: row.status === 'Failed',
              }">
              {{ row.status }}
            </span>
          </td>
          <td class="d-flex justify-content-end align-items-center custom-padding" (click)="setActiveRow(i)">
            <svg-icon alt="More" class="more-icon" src="assets/settings/more-icon.svg"></svg-icon>
          </td>
          <div *ngIf="activeRow === i" class="positioning">
            <div class="overlay-light" (click)="setActiveRow(null)"></div>
            <div class="dropdown-button p-2">
              <div class="dropdown-button-menu p-0 m-0">
                <div *ngIf="row.status === 'Failed'" class="dropdown-button-item p-2 d-flex justify-content-between"
                  (click)="downloadReport(row.id!)">
                  <span class="pe-2 item-title">{{
                    "DOWNLOADREPORT" | translate
                    }}</span>
                  <svg-icon alt="Download" class="hover-effect" src="assets/core/table/download.svg"></svg-icon>
                </div>
                <div class="dropdown-button-item p-2 d-flex justify-content-between" (click)="openProcessModal(row.id!)">
                  <span>{{ "PROCESSFILE" | translate }}</span>
                  <svg-icon alt="Process" class="hover-effect" src="assets/settings/process.svg"></svg-icon>
                </div>
                <div class="dropdown-button-item p-2 d-flex justify-content-between" (click)="downloadFile(row.id!)">
                  <span>{{ "DOWNLOADFILE" | translate }}</span>
                  <svg-icon alt="Download" class="hover-effect" src="assets/core/table/download.svg"></svg-icon>
                </div>
              </div>
            </div>
          </div>
        </tr>
      </tbody>
    </table>
    <div class="container-down">
      <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfItems" [pageSize]="pageSize"
        [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
    </div>
  </div>
</div>

<app-confirm-dialog *ngIf="showProcessModal" titleKey="PROCESSUPLOAD" question="PROCESSUPLOAD_DESCRIPTION"
  confirmText="OVERRIDE" cancelText="NOTIFYIFDUPLICATE"
  (confirm)="confirmProcess(true)" (cancel)="confirmProcess(false)"></app-confirm-dialog>
